export default {
      id: "logo-real-estate-usage",
      viewBox: "0 0 275 35",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#logo-real-estate",
      toString: function () {
        return this.url;
      }
    }